export default {
  lucky: {
    prizeAgain: 'Gire Novamente',
    prizeThanks: 'Mais Sorte na Próxima',
    remainingChance: 'Giros Restantes',
    task: 'Tarefa',
    deposit: 'Depósito',
    wager: 'Aposta',
    noChance: 'No spins available',
    drawFailed: 'Draw failed, please try again',
    prizeWin: 'Congratulations! You won {amount}',
    prizeAgainMsg: 'You got a free spin!',
  },
  card: {
    title: 'Coleção de Cartas',
    puzzleRound: 'Rodada {current}/{total}',
    puzzleReward: 'Recompensa completa {amount}',
    redeem: 'Resgatar',
    redeemSuccess: 'Resgatado com sucesso',
    redeemSuccessWithReward: 'Resgatado com sucesso! Você recebeu {amount} {currency}',
    redeemFailed: 'Falha ao resgatar',
    notComplete: 'Ainda não completo, não é possível resgatar',
    drawFailed: 'Falha ao sortear, tente novamente',
    gainLetter: 'Parabéns! Você obteve a letra {letter}',
    gainBlock: 'Parabéns! Você obteve a imagem {blockNo}',
    letterReward: '{redeemed}/{limit} · reward {amount}',
  },
  treasureChest: {
    invite: 'Convidar',
    claimReward: 'Resgatar',
    noChest: 'Sem baú',
    claimSuccess: '{count} baús resgatados, {amount} {currency}',
    modalTitle: 'Baú do tesouro',
    modalSubtitle: 'Deslize para ver todos',
    chipTodayClaimed: 'Resgatados hoje',
    chipClaimable: 'Resgatáveis',
    chipLocked: 'Bloqueados',
    totalClaimedCount: 'Total de baús resgatados',
    totalClaimedAmount: 'Total resgatado',
    chestUnit: 'pcs',
    claimAll: 'Resgatar tudo',
    goInvite: 'Convidar Agora',
    claimSingleSuccess: 'Resgatado {amount} {currency}',
    labelClaimed: 'Resgatado',
    labelClaimable: 'Resgatável',
    labelLocked: 'Bloqueado',
  },
}
